/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export enum EAdasProgramsEditSensorDialogType {
  EDIT_FROM_TABLE = 'EDIT_FROM_TABLE',
  EDIT_FROM_LOCATION = 'EDIT_FROM_LOCATION',
  ADD_GLOBAL = 'ADD_GLOBAL',
  ADD_FROM_LOCATION = 'ADD_FROM_LOCATION',
}


export interface SensorData {
  dialogType: string
  locationKey: string[]
  notes?: string
  oldLocationKey?: string[]
  oldSensorId?: string
  processedResolution?: string
  notSourced?: boolean
  sensorId: string
  sensorName: string
  sensorType: string
  version: string
}


export interface ReduxSensor {
  sensorId: string
  sensorName: string
  sensorType: string
  version: string
}
